import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { CustomState } from "@solveindustrial/Store/Reducers";
import { ContentFilters } from "@solveindustrial/Store/State/ContentSearch/ContentSearchState";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";

type HandlerType = HandlerWithResult<ContentFilters, ContentFilters>;

export const MergeParameter: HandlerType = props => {
    const state = props.getState() as CustomState;
    const currentFilters = cloneDeep(state.contentSearch.contentFilters);
    props.result = merge(currentFilters, props.parameter);
};

export const ResetPage: HandlerType = props => {
    if (props.parameter.pageSize || props.parameter.sort) {
        props.result.page = undefined;
    }
};

export const DispatchSetContentFilters: HandlerType = props => {
    props.dispatch({
        type: "ContentSearch/SetContentFilters",
        contentFilters: props.result,
    } as any);
};

export const chain = [MergeParameter, ResetPage, DispatchSetContentFilters];

const addContentFilters = createHandlerChainRunner(chain, "AddContentFilters");
export default addContentFilters;
